module.exports = __webpack_public_path__ + "img/i2.9b732a3c.png";